import { createContext, useContext, useState, ReactNode } from "react";
import { Vaad } from "../../../../../hooks/api/vaads";

interface VaadTabsContextType {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  vaadData?: Vaad;
  setVaadData: (data: Vaad) => void;
  selectedMiddahId?: string;
  setSelectedMiddahId: (id?: string) => void;
  middahOptions: Array<{ label: string; value: string }>;
  meetingsSubTab?: "future" | "past";
  setMeetingsSubTab: (tab: "future" | "past") => void;
}

const VaadTabsContext = createContext<VaadTabsContextType>({
  activeTab: "members",
  setActiveTab: () => { },
  vaadData: undefined,
  setVaadData: () => { },
  selectedMiddahId: undefined,
  setSelectedMiddahId: () => { },
  middahOptions: [],
  meetingsSubTab: "future",
  setMeetingsSubTab: () => { },
});

export const VaadTabsProvider = ({ children }: { children: ReactNode }) => {
  const [activeTab, setActiveTab] = useState("members");
  const [vaadData, setVaadData] = useState<Vaad | undefined>();
  const [selectedMiddahId, setSelectedMiddahId] = useState<
    string | undefined
  >();
  const [meetingsSubTab, setMeetingsSubTab] = useState<"future" | "past">(
    "future",
  );

  const middahOptions =
    vaadData?.learnedMiddahs?.map((m) => ({
      label: m.middah.name,
      value: m.middah.id,
    })) || [];

  return (
    <VaadTabsContext.Provider
      value={{
        activeTab,
        setActiveTab,
        vaadData,
        setVaadData,
        selectedMiddahId,
        setSelectedMiddahId,
        middahOptions,
        meetingsSubTab,
        setMeetingsSubTab,
      }}
    >
      {children}
    </VaadTabsContext.Provider>
  );
};

export const useVaadTabs = () => useContext(VaadTabsContext);
